import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {ColorFillPropertyType} from '@Components/color-fill';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import type {TranscriptActiveWordTextColorOptionProps} from './transcript-active-word-text-color-option.types';
import {SubtitleTemplateType} from '@PosterWhiteboard/items/transcript-item/subtitle/template-styles.types';
import {useGetKeyFromSubtitlePropertiesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitlePropertiesForTranscriptItem';
import {useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem';

export function TranscriptActiveWordTextColorOption({...props}: TranscriptActiveWordTextColorOptionProps): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptActiveWordTextColorOption');
  }

  const fillType = useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem('fillType', true);
  if (fillType === undefined) {
    throw new Error('Transcript item subtitle objects do not have fillType property in their activeWordTextStyles object');
  }

  const fillColor = useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem('fillColor', true);
  if (fillColor === undefined) {
    throw new Error('Transcript item subtitle objects do not have fillColor property in their activeWordTextStyles object');
  }

  const animationStyle = useGetKeyFromSubtitlePropertiesForTranscriptItem('animationStyle');
  if (!animationStyle) {
    throw new Error('Transcript item does not have animationStyle property in its subtitle objects');
  }

  const getFillType = (): ColorFillPropertyType => {
    if (fillType === FillTypes.LINEAR_GRADIENT) {
      return ColorFillPropertyType.LINEAR;
    }

    if (fillType === FillTypes.RADIAL_GRADIENT) {
      return ColorFillPropertyType.RADIAL;
    }

    return ColorFillPropertyType.SOLID;
  };

  return (
    <ContextualMenuColorFillOption
      id="transcript-highlight-word-text-color-option"
      label={animationStyle === SubtitleTemplateType.PROGRESS ? window.i18next.t('pmwjs_highlight_words_color') : window.i18next.t('pmwjs_highlight_word_color')}
      data={[
        {
          id: 'transcript-highlight-word-color-object',
          fillType: getFillType(),
          color: getColorObjectArrayFromFillColor(fillColor),
        },
      ]}
      onClick={() => {
        props.onActiveWordTextColorFillClick();
      }}
    />
  );
}
